// extracted by mini-css-extract-plugin
module.exports = {"addCollaborator":"AddUserWorkflowCollaboratorForm_addCollaborator__9mX_p"};